import { UploadErrorCode, UploadTaskStatus } from '@fabric-app/types/upload';
import { byteToMb } from '@fabric-app/utils/files';
import { getWoodyClient } from '../../woody/woody.js';
import { UploadError } from '../upload.error.js';

const initializeChunks = async (task, file, fileSize, options) => {
  const client = await getWoodyClient();
  if (task.chunked) {
    const { links, storagePath, uploadId } = await client.v2("/v2/upload/multipart", {
      query: {
        filename: task.data.file.name,
        size: task.data.file.size,
        chunkSizeInMb: byteToMb(task.chunkSize),
        folder: options.bucket,
        resourceId: options.resourceId
      }
    });
    const chunks2 = task.chunks.map((c) => {
      const link = links[c.index];
      if (!link) throw new UploadError(UploadErrorCode.ChunkMissingLink);
      const etag = Object.entries(link.headers).find(([key2]) => key2.toLowerCase() === "etag")?.[1];
      return {
        ...c,
        link,
        etag: etag ?? void 0
      };
    });
    return {
      chunks: chunks2,
      key: storagePath,
      uploadId,
      storagePath
    };
  }
  const presignedPost = await client.v2("/v2/upload", {
    query: {
      filename: encodeURIComponent(file.name),
      size: fileSize,
      folder: options.bucket,
      resourceId: options.resourceId
    }
  });
  const urlObj = new URL(presignedPost.url);
  const key = decodeURIComponent(urlObj.pathname.slice(1));
  const chunks = [
    {
      index: 0,
      status: UploadTaskStatus.Pending,
      progress: 0,
      uploadSpeed: 0,
      size: fileSize,
      link: presignedPost,
      retries: 0
    }
  ];
  return {
    chunks,
    key,
    uploadId: "",
    storagePath: key
  };
};

export { initializeChunks };
//# sourceMappingURL=initializeFileChunks.js.map
